/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_TICKET_URL, COMMON_HEADER_CONFIG} from "../config";

class TicketService {
  getAccessToken = () => localStorage.getItem("accessToken");

  getListTickets = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_TICKET_URL}/ticket`,
        params: {
          size: 100,
          page: 1,
          ...data
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error.response.data.error);
        });
    });

  updateTicket = (data) =>
    new Promise((resolve, reject) => {
      const dataUpdate = JSON.stringify(data);
      const config = {
        method: "put",
        url: `${API_TICKET_URL}/ticket/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data: dataUpdate
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListTicketHistories = (data) =>
    new Promise((resolve, reject) => {
      const params = {
        size: 500,
        page: 1,
        limit: data.limit
      };
      if ("state" in data) {
        params.state = data.state;
      }
      const config = {
        method: "get",
        url: `${API_TICKET_URL}/ticket-history/${data.ticket_id}`,
        params,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const ticketService = new TicketService();

export default ticketService;
